module.exports = require("npm:redux-watch@1.1.1/index.js");